import { Injectable } from '@angular/core';
import { Cookie } from 'ng2-cookies/ng2-cookies';
import { LoggerService } from './logger.service';
const JL = require('jsnlog').JL;

declare var _paragonConfig: PgRendererDto.ParagonAppConfig;

@Injectable()
export class AuthService {

    private accessToken: string;

    constructor(
        private loggerService: LoggerService
    ) {
    }

    setAccessToken(accessToken: string) {
        this.accessToken = accessToken;
        this.loggerService.setAccessToken(accessToken);
    }

    setWebDeliveryAuth(webDeliveryAuth: string) {
        sessionStorage.setItem('webDeliveryAuth', webDeliveryAuth);
    }

    getAccessToken(): string {
        const token = Cookie.get('token');
        if (token) {
            return token;
        }
        return this.accessToken;
    }

    getWebDeliveryAuth() {
        return sessionStorage.getItem('webDeliveryAuth');
    }
}



// WEBPACK FOOTER //
// C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/services/auth.service.ts